import { DropdownItem } from "src/Interfaces/dropdownInterfaces";
import { CoveredMatrixExecutionMethod,CoveredMatrixCriterionType,CoveredMatrixVolumeCalculationType,CreateCoveredMatrixOrderRequest } from "src/Interfaces/coveredMatrixOrder";
import { ITableReport } from "src/Interfaces/TableInterfaces";

export const defaultCriterionType=CoveredMatrixCriterionType.MinDailyReturn;

export const tableRefreshInterval=10000;

export const maximumCostCriterion=CoveredMatrixCriterionType.MaxCost;

export const fixedCallPriceCriterion=CoveredMatrixCriterionType.FixedCallPrice;

export const criterionName=(type: number) => {
  if(type===maximumCostCriterion)
    return "حداکثر بهای تمام شده";
  if(type===fixedCallPriceCriterion)
    return "حداقل قیمت کال";
  return "حداقل % بازده روزانه";
};

export const isMaximumCostCriterion=(type: number) => type===maximumCostCriterion;

export const isFixedCallPriceCriterion=(type: number) => type===fixedCallPriceCriterion;

export const formatCriterionValue=(value: number|null|undefined,type=defaultCriterionType) => {
  if(value===null||value===undefined)
    return "-";
  const numericValue=Number(value);
  if(!Number.isFinite(numericValue))
    return "-";
  if(isFixedCallPriceCriterion(type))
    return numericValue.toLocaleString("en-US",{ maximumFractionDigits: 0 });
  const displayedValue=Math.abs(numericValue).toLocaleString("en-US",{ maximumFractionDigits: 3 });
  return numericValue<0? `${displayedValue}-`:displayedValue;
};

export const criterionOptionsForExecutionMethod=(executionMethod: CoveredMatrixExecutionMethod): DropdownItem[] => [
  { id: defaultCriterionType,name: criterionName(defaultCriterionType) },
  { id: maximumCostCriterion,name: criterionName(maximumCostCriterion) },
  ...(executionMethod===CoveredMatrixExecutionMethod.BothSides
    ? []
    :[{ id: fixedCallPriceCriterion,name: criterionName(fixedCallPriceCriterion) }]),
];

export const executionMethodOptions: DropdownItem[]=[
  { id: CoveredMatrixExecutionMethod.BothSides,name: "ارسال هر دو سمت" },
  { id: CoveredMatrixExecutionMethod.BaseAlreadyOwned,name: "موجود بودن نماد پایه" },
  { id: CoveredMatrixExecutionMethod.FutureBasePurchase,name: "قیمت ثابت نماد پایه" },
];

export const volumeOptions: DropdownItem[]=[
  { id: CoveredMatrixVolumeCalculationType.FixedAmount,name: "مقدار ثابت" },
  { id: CoveredMatrixVolumeCalculationType.AssetPercent,name: "% از دارایی نماد پایه" },
  { id: CoveredMatrixVolumeCalculationType.CoveredCallImbalancePercent,name: "% از ناترازی گروه پرتفو کاوردکال" },
];

export const sendOrderTypeOptions: DropdownItem[]=[
  { id: 0,name: "خودکار" },
  { id: 1,name: "اعتباری" },
  { id: 2,name: "غیر اعتباری" },
];

export const emptyDraft=(): CreateCoveredMatrixOrderRequest => ({
  accountIds: [],
  baseIsin: "",
  executionMethod: CoveredMatrixExecutionMethod.BothSides,
  manualBaseReferencePrice: null,
  volumeCalculationType: CoveredMatrixVolumeCalculationType.FixedAmount,
  volumeInput: 0,
  sendOrderType: 0,
  items: [],
});

export type ModalType="options"|"criteria"|"preview"|"connections"|"edit"|null;

export interface CoveredMatrixPreviewTableRow extends ITableReport {
  accountName: string;
  baseSymbolName: string;
  optionName: string;
  optionNameClassname?: string;
  executionMethodName: string;
  baseHoldingVolume: string;
  baseTargetVolume: string;
  optionEquivalentVolume: string;
  optionEquivalentVolumeClassname?: string;
  targetCriterionName: string;
  targetCriterionNameClassname?: string;
  targetCriterionValue: string;
  targetCriterionValueClassname?: string;
  sendOrderTypeName: string;
}

export interface BaseOrderBookTableRow extends ITableReport {
  buyVolume: string;
  buyPrice: string;
  sellPrice: string;
  sellVolume: string;
  buyVolumeClassname?: string;
  buyPriceClassname?: string;
  sellPriceClassname?: string;
  sellVolumeClassname?: string;
}
